var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"CategoryMedia"},[(!_vm.isAudio)?_c('CategoryImage',{attrs:{"src":_vm.media}}):_vm._e(),(_vm.isAudio)?_c('AudioButton',{attrs:{"sound":_vm.media,"note":_vm.category}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }